import MedicationsItem from './MedicationsItem'

export default MedicationsItem
